import React from 'react';

import State from 'Common/renderers/State/State';

export const IsDirectState: React.FC<{ isDirect: string }> = ({ isDirect }) =>
  isDirect === 'Yes' ? (
    <State title="Flow is direct" className="status-green" text="Yes" />
  ) : (
    <State title="Flow is indirect (hops in the path)" className="status-red" text="No" />
  );
